import React from 'react';

import {OrderWidget} from '/component/partial/OrderWidget';

import {styles} from './FirstOrder.style';

export const NoOrder = () => {
  return (
    <OrderWidget
      title="First order"
      orderStatus="noOrder"
      style={{basePadding: styles.noOrderPadding}}
    />
  );
};
